import styled from "styled-components"
import { Colors } from "styles/app-styles"

export const Defaults_s = styled.div`
  padding: 15px;
  > div {
    display: flex;
    flex-direction: column;
    padding: 15px 15px 0 15px;
    hr {
      border-top: 1px solid ${Colors.towerGrey};
      border-bottom: none;
      margin: 10px 0 20px 0;
      width: 100%;
    }
    > div {
      display: flex;
      flex-wrap: wrap;
    }
    > div > div {
      display: flex;
      flex-direction: column;
    }
  }
  > div:nth-child(2n) {
    background-color: ${Colors.inputFocus};
    border: 1px solid ${Colors.towerGrey};
    margin: 20px 10px 10px 10px;
  }
  > div > div, > div > div > div {
    margin-right: 20px;
  }
  .has-errors {
    border-bottom-width: 1px !important;
    border-bottom-color: ${Colors.colorDanger} !important;
  }
  select {
    margin-bottom: 15px;
    width: 220px;
  }
`

export const DefaultsCommercial_s = styled.div`
  margin: -30px -30px 0 5px;
  div.p-tabview-panels {
    margin: -15px 0px 0 -20px;
  }
  ul.p-tabview-nav > li.p-disabled {
    display: none;
  }
`

export const DefaultsMultifamily_s = styled.div`
  margin-top: -40px;
`